import React, { useState, useEffect, useRef } from 'react';

interface Option {
	value: string;
	label: string;
}

const IndicatorTabs: React.FC<{
	options: Option[];
	value?: Option;
	onChange?: (option: Option) => void;
}> = ({ options = [], value, onChange }) => {
	const [valueData, setValueData] = useState<Option>(value || options[0]);
	const [tabStyle, setTabStyle] = useState({});
	const tabRef: any = useRef(null);

	useEffect(() => {
		const activeTabElement = tabRef.current.querySelector('.activeTab');
		const newTabStyle = {
			left: activeTabElement.offsetLeft,
			width: activeTabElement.offsetWidth,
		};
		setTabStyle(newTabStyle);
	}, []);

	const handleTabClick = (tabId: Option) => {
		const newActiveTabElement = tabRef.current.querySelector(`#tab-${tabId?.value}`);
		const newTabStyle = {
			left: newActiveTabElement.offsetLeft,
			width: newActiveTabElement.offsetWidth,
		};
		setTabStyle(newTabStyle);
		setValueData(tabId);
	};

	return (
		<div
			id="indicatorTabs"
			ref={tabRef}
			className="flex max-w-fit font-[600] items-center bg-white dark:bg-[#18222D] border border-[#EBEBF0] dark:border-[#c7c9d91a] rounded-[inherit] p-1 gap-2 isolate relative"
		>
			{options.map(option => (
				<button
					id={`tab-${option.value}`}
					key={option.value}
					className={`tab relative py-2 px-4 transition-all rounded-[inherit] ${
						valueData?.value?.toLowerCase() === option?.value?.toLowerCase()
							? 'activeTab text-white'
							: 'text-inherit hover:bg-[#CDF] dark:hover:text-black'
					}`}
					onClick={e => {
						setValueData(option);
						onChange && onChange(option);
						handleTabClick(option);
					}}
				>
					{option.label}
				</button>
			))}

			<div
				id="indicator"
				className="absolute rounded-[inherit] h-[calc(100%_-_8px)] z-[-1] my-auto inset-0 bg-[#7777E7] transition-all"
				style={tabStyle}
			/>
		</div>
	);
};

export default IndicatorTabs;
